import React from 'react';

const Container = (props) => (
    <div className={`ml-auto mr-auto pl-4vw pr-4vw u-maxWidth1140 mx-auto`}>
        {props.children}
    </div>
);

export default Container;